export const gutterWidthLg = 32;
export const gutterWidthSm = 8;
export const pageMaxWidth = 2000;
export const pageContainerSpacing = {
	sm: 16,
	md: 32,
	lg: 40,
};

export const toEmMedia = px => px / 16;

export const breakpointsPx = {
	sm: 320,
	md: 768,
	lg: 1024,
	xl: 1440,
	xxl: 1920,
};

export const breakpointsEm = {
	sm: toEmMedia(breakpointsPx.sm),
	md: toEmMedia(breakpointsPx.md),
	lg: toEmMedia(breakpointsPx.lg),
};

const theme = {
	breakpoints: ['320px', '375px', '425px', '768px', '1024px', '1440px', '1920px'],
	colors: {
		primaryLight: '#FF5252',
		primary: '#FF0000',
		primaryDark: '#DF0000',
		secondaryLight: '#59c5d4',
		secondaryLightest: '#F2FDFF',
		secondary: '#23B2C6',
		secondaryDark: '#1fa1b3',
		borderLight: '#f2f2f2',
		borderColor: '#E2E6E9',
		borderDark: '#CCC',
		textColor: '#626e77',
		textDark: '#4E555A',
		textDarker: '#363B3D',
		grayLighter3: '#D3DCE3',
		grayLighter2: '#F2F6F9',
		grayLighter: '#EFF3F6',
		grayLight: '#D4E0E9',
		gray: '#626e77',
		grayDarker: '#4E555A',
		grayTransparent: '#f4f4f4f0',
		black: '#212223',
		white: '#fff',
		yellow: '#d6cd18',
		grayDate: '#96A0A8',
		grayTitle: '#353A3D',
		graySummary: '#6D767C',
		lightGrayBorder: '#F1F1F1',
		pureBlack: '#000000',
	},
	colorsV2: {
		grey1: '#FCFCFD',
		grey2: '#F6F6F6',
		grey3: '#F3F3F3',
		grey4: '#EDEDED',
		grey5: '#DFDFDF',
		grey6: '#989898',
		grey7: '#666666',
		grey8: '#4E4E4E',
		grey9: '#333333',
		grey10: '#181818',
		mainRed: '#FF0000',
		mainPink: '#FF6DB1',
		mainBeige: '#ECDEAA',
		mainDark: '#3C3C3C',
		secondaryRed: '#D40000',
		lightRed: '#FF4646',
		alertRed: '#A41208',
		alertGreen: '#27564A',
		alertRedSecondary: '#FF7870',
		alertGreenSecondary: '#66D8BA',
		alertYellowSecondary: '#FEC576',
	},
	fonts: {
		SharpSlab: '"Sharp Slab", Arial',
    Arimo: '"Arimo", Arial, sans-serif',
    ArimoBold: '"Arimo Bold", Arial, sans-serif',
    ArimoMedium: '"Arimo Medium", Arial, sans-serif',
    ArimoRegular: '"Arimo", Arial, sans-serif',
		fontSize: '1.8rem',
		lineHeight: 1.6,
		weight: {
			regular: 400,
			medium: 500,
			semiBold: 600,
			bold: 700,
		},
	},
	header: {
		height: '8rem',
		desktopHeight: '12.8rem',
	},
	routeTransitions: {
		enterDuration: 400,
		exitDuration: 400,
	},
	pageMaxWidth: 125,
	pageMaxWidthLarger: 167,
	toolbars: {
		mobileToolbarHeight: '8rem',
		openingTimesToolbarHeight: '6.9rem',
	},
	flexboxgrid: {
		gridSize: 12,
		gutterWidth: gutterWidthLg / 16,
		outerMargin: 0,
		mediaQuery: 'only screen',
		breakpoints: {
			xs: 0,
			...breakpointsEm,
		},
	},
};

export default theme;
